import { render, staticRenderFns } from "./CoverholderSuite.vue?vue&type=template&id=0a819819&"
import script from "./CoverholderSuite.vue?vue&type=script&lang=js&"
export * from "./CoverholderSuite.vue?vue&type=script&lang=js&"
import style0 from "./CoverholderSuite.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports